import { render, staticRenderFns } from "./index-by-coa.vue?vue&type=template&id=028d3d78&scoped=true"
import script from "./index-by-coa.vue?vue&type=script&lang=js"
export * from "./index-by-coa.vue?vue&type=script&lang=js"
import style0 from "./index-by-coa.vue?vue&type=style&index=0&id=028d3d78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028d3d78",
  null
  
)

export default component.exports